module.exports = __webpack_public_path__ + "static/00016.e17dbd50.jpg";